import { FC } from "react";
import { SidebarLinkPathTypes, SidebarLinkTypes } from "../../LinkTypes";
import { BaseComplexSidebarLink, ComplexLinkProps } from "./BaseComplexSidebarLink";
import { DocumentIcon } from "../../../../assets/icons/Icons";
import { useTranslation } from "react-i18next";

export const DocumentManagementComplexLink: FC<ComplexLinkProps & { submenuLinks?: string[] }> = ({
  activePathname,
  collapsed,
  showText,
  submenuLinks = [],
}) => {
  const { t } = useTranslation();
  const links = submenuLinks.includes("CertificatesAndTraining")
    ? [
        {
          linkName: SidebarLinkTypes.documentManagementCertificatesTrainings,
          path: SidebarLinkPathTypes.documentManagementCertificatesTrainings,
        },
      ]
    : [];

  if (!links.length) return null;

  return (
    <BaseComplexSidebarLink
      activePathname={activePathname}
      collapsed={collapsed}
      showText={showText}
      icon={<DocumentIcon color="white" />}
      label={t(SidebarLinkTypes.documentManagement)}
      links={links}
    />
  );
};